import { Grid, Typography } from '@mui/material'
import React, { Fragment } from 'react'
import { handleColorState } from '../asnUtils'

interface AsnDisplayStateProps {
  asnStateName: string
}

export const AsnDisplayState: React.FC<AsnDisplayStateProps> = ({
  asnStateName
}) => {
  return (
    <Fragment>
      <Grid item xs={12} sm={12} md={4} lg={4}>
        <Typography variant='h6' component='p'>
          <b style={{ display: 'inline-block', marginRight: '10px' }}>
            Estado:
          </b>
          <p
            style={{
              color: handleColorState(asnStateName),
              display: 'inline-block'
            }}
          >{` ${asnStateName}`}</p>
        </Typography>
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
    </Fragment>
  )
}
